<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.notifications") }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('settings.receiptEmail')">
          <b-switch
            size="is-small"
            class="notification-switch"
            type="is-primary"
            v-model="storeBeingManaged.notifications.merchant.transactionEmail"
            passive-type="is-secondary"
            @input="setNotification('transactionEmail')"
          ></b-switch>

          {{
            storeBeingManaged.notifications.merchant.transactionEmail
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('settings.stockoutEmail')">
          <b-switch
            size="is-small"
            class="notification-switch"
            type="is-primary"
            v-model="storeBeingManaged.notifications.merchant.stockoutEmail"
            passive-type="is-secondary"
            @input="setNotification('stockoutEmail')"
          ></b-switch>

          {{
            storeBeingManaged.notifications.merchant.stockoutEmail
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  methods: {
    setNotification(notification) {
      this.isLoading = true;
      this.$store
        .dispatch("setNotification", {
          notification,
          status: this.storeBeingManaged.notifications.merchant[notification],
          storeId: this.storeBeingManaged._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
            this.storeBeingManaged.notifications.merchant[notification] = !this
              .storeBeingManaged.notifications.merchant[notification];
          } else {
            this.$buefy.toast.open({
              message: `${this.$t("settings.notification")} ${
                this.storeBeingManaged.notifications.merchant[notification]
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.notifications.merchant[notification] = !this
            .storeBeingManaged.notifications.merchant[notification];
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.notification-switch {
  position: relative;
  top: 2px;
}
</style>
